<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      parent="CcMeHistoryModal"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        class="action"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <span slot="taskStatus" slot-scope="text, record">
          <a-tag color="green" v-if="record.taskStatus == 'disp.flow.end'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="red" v-else-if="record.taskStatus == 'disp.flow.refuse'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag v-else-if="record.taskStatus == 'disp.flow.cancel'">{{ $t(record.taskStatus) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>
          <a-divider type="vertical" />
          <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
            $t('disp.flow.history')
          }}</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal"></apply-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import TrackModal from './TrackModal'
import SearchArea from './SearchArea'

export default {
  name: 'CcMeHistoryModal',
  mixins: [tableMixin, flowMixin],
  components: {
    TrackModal,
    SearchArea,
  },
  data() {
    return {
      description: '抄送给我的流程・终了',
      showLoadingBySearch: true,
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'processDefinitionName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/ccMeHistory/list',
      },
    }
  },
  computed: {},
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    handleOpen(record) {
      this.$openWF(record.processInstanceId)
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
  },
}
</script>
